import moment from 'moment-timezone';
import {statusColor} from "../assets/utils/statusColors";


export function formatPrice(number) {
    return new Intl.NumberFormat('en-US').format(number);
}

export function formatDate(date, format = 'MMMM D, YYYY') {
    // return moment(date).format(format);
     return moment.utc(date).tz('Asia/Dubai').format(format);
}

export function timeAgo(date) {
    return moment(date).fromNow();
}

export function getNextStatus(currentStatus) {
    const statusArray = Object.keys(statusColor); // Convert object values to array
    const currentIndex = statusArray.indexOf(currentStatus);
    if (currentIndex === -1 || currentIndex === statusArray.length - 1) {
        return null;
    }
    return statusArray[currentIndex + 1];
}


// Function to convert array of objects to CSV string
const convertToCSV = (data, headersMap = null) => {
  if (!data || data.length === 0) return '';
  
  const headers = headersMap ? Object.keys(headersMap) : Object.keys(data[0]);
  const headerNames = headersMap ? Object.values(headersMap) : headers;
  
  let csv = headerNames.join(',') + '\n';
  
  data.forEach(row => {
    const values = headers.map(header => {
      let value = row[header] !== undefined ? row[header] : '';
      
      // Escape quotes and handle commas
      if (typeof value === 'string') {
        value = value.replace(/"/g, '""');
        if (value.includes(',')) {
          value = `"${value}"`;
        }
      }
      return value;
    });
    csv += values.join(',') + '\n';
  });
  
  return csv;
};


// Function to format a date to a readable string
export function exportCSV(data, columns, filename) {
        data = convertToCSV(data, columns);
    
        const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);
        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename+'.csv'); // Set file name

        // Trigger the download directly
        link.style.display = 'none'; // Ensure the link is not visible
        document.body.appendChild(link);
        link.click(); // Programmatically click the link
        document.body.removeChild(link); // Remove link after triggering download
        // Revoke the URL to free up resources
        window.URL.revokeObjectURL(url);
}
  
  